import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useMemo } from 'react';
import { DOTS } from "./constants";

var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, index) {
    return index + start;
  });
};

export var usePageNavigator = function usePageNavigator(_ref) {
  var activePage = _ref.activePage,
      totalItems = _ref.totalItems,
      amountAdjacentItems = _ref.amountAdjacentItems,
      itemsPerPage = _ref.itemsPerPage;

  /**
   * рассчитываем кол-во страниц в зависимости от количество элементов на странице.
   */
  var total = useMemo(function () {
    return Math.ceil(totalItems / itemsPerPage);
  }, [totalItems, itemsPerPage]); // eslint-disable-next-line consistent-return

  return useMemo(function () {
    var totalPageNumbers = 3 + 2 + amountAdjacentItems;

    if (totalPageNumbers >= total) {
      return range(1, total);
    }

    var leftSiblingIndex = Math.max(activePage - amountAdjacentItems, 1);
    var rightSiblingIndex = Math.min(activePage + amountAdjacentItems, total);
    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex <= total - 2;
    var firstPageIndex = 1;
    var lastPageIndex = total;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = 3 + 2 * amountAdjacentItems;
      var leftRange = range(1, leftItemCount);
      return [].concat(_toConsumableArray(leftRange), [DOTS, total]);
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = 3 + 2 * amountAdjacentItems;
      var rightRange = range(total - rightItemCount + 1, total);
      return [firstPageIndex, DOTS].concat(_toConsumableArray(rightRange));
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      var middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS].concat(_toConsumableArray(middleRange), [DOTS, lastPageIndex]);
    }
  }, [total, amountAdjacentItems, activePage]);
};